import { resourceCreatorName } from '../../../components/only-mine-filter'
import { useContext, useState } from "react";
import { DashboardContext } from "../../../dashboard-context";
import styled from "styled-components";
import moment from "moment";
import { Link } from "react-router-dom";
import Modal from "../../../../../components/modal";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import PeopleIcon from "@material-ui/icons/People";
import AssignClientsModal from "./assign-clients-modal";
import { AuthContext } from "../../../../../auth-context";
import { deletePortalSurvey, loadProfile } from "../../../../../api";

const Card = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  /* max-width: 1100px; */
  width: 100%;
  margin: 10px 0px;

  @media (max-width: 900px) {
    flex-wrap: wrap;
    gap: 12px;
  }
`;

const MetaData = styled.div`
  display: flex;
  flex-direction: column;
  p {
    font-size: 0.9rem;
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  a {
    align-items: center;
    border-radius: 6px;
    color: #08091f;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    min-width: 50px;
    padding: 6px 4px;
    text-decoration: none;
    &:hover {
      background: #e1e1e1;
    }
  }

  a svg {
    height: 15px;
  }

  span {
    color: #08091f;
    font-size: 0.7rem;
    padding-top: 2px;
    text-align: center;
  }
`;

const CopyButton = styled.button`
  background-color: #e5e5e5;
  border-radius: 6px;
  color: #454545;
  padding: 2px 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.8rem;
  font-weight: 500;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #d5d5d5;
  }
`;

const IconActionButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  border-radius: 6px;
  color: #08091f;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-family: inherit;
  justify-content: center;
  min-width: 50px;
  padding: 6px 4px;

  svg {
    height: 15px;
  }

  &:hover {
    background: #e1e1e1;
  }
`;

const DeleteButton = styled(IconActionButton)`
  color: #da0f0f;
`;

const FormName = styled.h4`
  color: #555;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
`;

const FormCard = ({ form, forms, setForms }) => {
  const { user, updateUser } = useContext(AuthContext);
  const { openSnackbar } = useContext(DashboardContext);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [showAssignments, setShowAssignments] = useState(false);

  const deleteForm = () => {
    setDeleting(true);

    deletePortalSurvey(user.id, form.id)
      .then(() => {
        setForms(forms.filter((f) => f.id !== form.id));
        loadProfile(user.id).then((res) => {
          updateUser(res.data.profile);
        });
        setDeleting(false);
        setShowDeleteModal(false);
        openSnackbar("Form deleted", false);
      })
      .catch(() => {
        setDeleting(false);
        setShowDeleteModal(false);
        openSnackbar("There was a problem deleting this form.", true);
      });
  };

  const handleCopyId = () => {
    navigator.clipboard.writeText(form.share_id);
    openSnackbar("Form ID copied to clipboard", false);
  };

  return (
    <Card>
      <MetaData>
        <h3>{form.name || "Untitled Form"}</h3>
        <p>Created by: {resourceCreatorName(form, user)}</p>
        <p>
          Created {moment.utc(form.created_at).format("MMM D, YYYY")}{" "}
        </p>
      </MetaData>

      <Actions>
        <CopyButton onClick={handleCopyId}>Copy ID</CopyButton>
        <IconActionButton type="button" onClick={() => setShowAssignments(true)}>
          <PeopleIcon />
          <span>Assign Clients</span>
        </IconActionButton>
        <Link to={`/dashboard/forms/edit/${form.id}`}>
          <EditIcon />
          <span>Edit</span>
        </Link>
        <DeleteButton
          aria-label={`Delete ${form.name || "Untitled Form"}`}
          onClick={() => setShowDeleteModal(true)}
          type="button"
        >
          <DeleteIcon />
          <span>Delete</span>
        </DeleteButton>
      </Actions>
      <AssignClientsModal
        open={showAssignments}
        onClose={() => setShowAssignments(false)}
        surveyID={form.id}
      />
      <Modal
        disabled={deleting}
        handleSubmit={deleteForm}
        isLoading={deleting}
        message="Are you sure you want to delete this check-in form? This action cannot be undone."
        onClose={() => setShowDeleteModal(false)}
        open={showDeleteModal}
        submitLabel="Delete"
        title="Delete Check-in Form"
        warning
      >
        <FormName>{form.name || "Untitled Form"}</FormName>
      </Modal>
    </Card>
  );
};

export default FormCard;
